import React, { useEffect, useState } from "react";
import styles from "./PreviewCheckbox.module.scss";
import { ReactComponent as MoreInfoIcon } from "assets/svg/InformationIcon.svg";
import { ReactComponent as CrossIcon } from "assets/svg/x.svg";
import { useDispatch } from "react-redux";
import { setSelectedOptionsForFormula } from "@redux/slices/scoringSlice";

const PreviewCheckbox = (props) => {
  const [showIcon, setShowIcon] = useState(
    props?.data?.showInstructions || false
  );
  const [conditionResult, setConditionResult] = useState(false);
  const [active, setActive] = useState(false);

  const dispatch = useDispatch();
  const handleOptionChange = () => {
    setActive((prev) => {
      dispatch(
        setSelectedOptionsForFormula({
          id: props.id || props?._id,
          value: prev ? "Unchecked" : "Checked",
        })
      );

      return !prev;
    });
  };

  // useEffect(() => {
  //   dispatch(
  //     setSelectedOptionsForFormula({
  //       id: props.id,
  //       value: !active ? "Unchecked" : "Checked",
  //     })
  //   );
  // }, []);
  useEffect(() => {
    const checkCondition = () => {
      switch (active) {
        case true:
          return props?.whenAnswerEquals === "checked";
        case false:
          return props?.whenAnswerEquals === "unchecked";
        default:
          return false;
      }
    };

    const result = checkCondition();
    setConditionResult(result); // Store the result in state
  }, [active, props?.whenAnswerEquals]);


  return (
    <div className={styles.mainContainer}>
      <div className={styles.mainContent}>
        <div className={styles.heading}>
          <span>
            {props?.data?.required && <span style={{ color: "red" }}>*</span>}
            {props?.data?.value || props?.name || props?.label}
          </span>
          {props?.instructions || props?.data?.media?.length ? (
            <div>
              {showIcon ? (
                <CrossIcon onClick={() => setShowIcon((prev) => !prev)} />
              ) : (
                <MoreInfoIcon onClick={() => setShowIcon((prev) => !prev)} />
              )}
            </div>
          ) : null}
        </div>

        <div className={styles.buttonContainer}>
          <input
            type="checkbox"
            checked={active}
            onChange={() => handleOptionChange()}
            className={styles.active}
          />
        </div>
      </div>
      {showIcon && (
        <div className={styles.subContent}>
          {props?.instructions && (
            <div className={styles.instructionText}>
              {props?.instructions}
            </div>
          )}
          {props?.data?.media?.length ? (
            <>
              {props?.data?.media.map((image) => (
                <img
                  className={styles.imageStyle}
                  src={image.path}
                  alt="Preview"
                />
              ))}
            </>
          ) : null}
        </div>
      )}
      {

      }
      {

        conditionResult && props?.dependentField?.map((ele) => {
          return props?.renderContent(ele)
        })
      }
    </div>
  );
};

export default PreviewCheckbox;
